import { useState, useCallback } from 'react';
import { getBlockingTasks } from '../utils/sequentialTasks';

/**
 * Hook for managing blocking tasks highlight state
 * @param {Object} params - Configuration object
 * @param {Array} params.tasks - All tasks
 */
export function useBlockingTasksHighlight({
  tasks
}) {
  const [blockingTasksHighlight, setBlockingTasksHighlight] = useState(new Set());

  const handleBlockedIconMouseEnter = useCallback((clientId) => {
    // Find task by clientId
    const task = tasks.find(t => t._reactKey === clientId);
    if (!task) return;
    
    const blockingTasks = getBlockingTasks(task.id, tasks); // Use database ID for logic
    // Convert blocking task IDs to clientIds
    const blockingClientIds = blockingTasks.map(blockingId => {
      const blockingTask = tasks.find(t => t.id === blockingId);
      return blockingTask ? blockingTask._reactKey : null;
    }).filter(Boolean);
    // Include the hovered task so its checkbox also gets the bold border
    setBlockingTasksHighlight(new Set([clientId, ...blockingClientIds]));
  }, [tasks]);

  const handleBlockedIconMouseLeave = useCallback(() => {
    setBlockingTasksHighlight(new Set());
  }, []);

  return {
    blockingTasksHighlight,
    handleBlockedIconMouseEnter,
    handleBlockedIconMouseLeave
  };
}
